/* eslint-disable no-restricted-globals */
import { IconButton } from '@mui/material';
import React from 'react';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

export type ICartProps = {

}

const Cart: React.FC<ICartProps> = ({ }) => {
  return (
    <div style={{
      display: 'flex',
      marginRight: '10px',
      alignItems: 'center',
    }}
    >
      <IconButton
        size="large"
        onClick={() => {
          location.href = '/cart';
        }}
      >
        <ShoppingCartOutlinedIcon />
      </IconButton>
    </div>
  );
};

export { Cart };
